import axios from '@api'

export default {
    getModifyType() {
      return axios.get(`api/management/modifytype`);
    },
    deleteModifyType(modifyTypeId) {
      return axios.put(`api/management/modifytype/delete/${modifyTypeId}`);
    },
    saveModifyType(json) {
      return axios.post(`api/management/modifytype/save`, json);
    }
}